import { ref, type Ref, toValue } from 'vue'
import type {
    AnyVariables,
    OperationContext,
    OperationResult,
} from '@urql/core'
import type { DocumentNode } from 'graphql/language/ast'
import { createRequest, type Client } from '@urql/vue'

export interface SimpleMutationResponse<T, V> {
    fetching: Readonly<Ref<boolean>>
    executeMutation(
        variables: V,
        context?: Partial<OperationContext>
    ): Promise<OperationResult<T>>
}

export function adaptMutation<T, V extends AnyVariables = AnyVariables>(
    client: Ref<Client>,
    document: DocumentNode
): SimpleMutationResponse<T, V> {
    const fetching = ref(false)

    const executeMutation = async <V extends AnyVariables = AnyVariables>(
        variables: V,
        context?: Partial<OperationContext>
    ): Promise<OperationResult<T>> => {
        fetching.value = true

        const result = await toValue(client).executeMutation<T, V>(
            createRequest<T, V>(document, variables),
            context || {}
        )

        fetching.value = false

        return result
    }

    return {
        fetching,
        executeMutation,
    }
}
